import {request} from "../../../res/rest/restRequest";
import {api} from "../../../res/rest/api";
import {env} from "../../../res/config/env";
import HttpClient from "../../services/http/HttpClient";
import {idempiereProcess} from "../../../res/rest/process";

const fetchInstitutionsAction = async (session) => {
    const req = request.process(api.PROCESS.YAPILY_GET_INSTITUTIONS);
    const url = env.API_URL + req.buildRequest();
    const resp = await HttpClient.client.post(url, req.buildRequestBody(), api.auth(session));
    const data = idempiereProcess.handleResponseThrowingException(resp);
    return JSON.parse(data.summary);
};

export default fetchInstitutionsAction;
